import { Reducer, combineReducers } from "redux";
import applicant from "./applicant/reducer";
import storage from "./storage/reducer";
import recruiter from "./recruiter/reducer";
import auth from "./auth/reducer";
import requestStore from "./request/reducer";
import logs from "./logs/reducer";
import comment from "./comment/reducer";
import user from "./user/reducer";
import position from "./position/reducer";
import notification from "./notification/reducer";
import interviewer from "./interviewer/reducer";

const allReducers: Reducer = combineReducers({
  applicant,
  storage,
  recruiter,
  auth,
  user,
  requestStore,
  logs,
  comment,
  position,
  notification,
  interviewer,
});

export default allReducers;
